import { useCallback, useEffect, useState } from 'react';
import dayjs from 'dayjs';

export const useCountdown = (endTime) => {
  const calculateTimeLeft = useCallback(() => {
    if (!endTime) {
      return 0;
    }
    return dayjs(endTime).diff(dayjs(), 'seconds');
  }, [endTime]);

  const [countDown, setCountDown] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [calculateTimeLeft]);

  return getCountdownReturnValues(countDown);
};

const getCountdownReturnValues = (timeRemaining) => {
  const days = Math.max(Math.floor(timeRemaining / (60 * 60 * 24)), 0);
  const hours = Math.max(
    Math.floor((timeRemaining % (60 * 60 * 24)) / (60 * 60)),
    0
  );
  const minutes = Math.max(Math.floor((timeRemaining % (60 * 60)) / 60), 0);
  const seconds = Math.max(Math.floor(timeRemaining % 60), 0);

  return [days, hours, minutes, seconds];
};
